export const ENHANCER_ATTRIBUTE = 'data-enhancer';
export const HANDLER_ATTRIBUTE = 'data-handler';
